<template>
  <div class="author-info-header">
    <div class="author-info-left">
      <div
        class="head-img"
        :style="{ 'background-image': `url('${avatar}')` }"
      ></div>
      <div class="head-text">
        <span class="name">{{ authorInfo.nickname }}</span>
        <div class="title">
          <span>{{ authorType }}</span>
          <div class="line"></div>
          <span>{{ authorInfo.corp }}</span>
        </div>
      </div>
    </div>
    <div class="author-info-right">
      <div class="block" v-for="item in blockData" v-bind:key="item.name">
        <div class="block-left">
          <span class="name">{{ item.name }}</span>
          <span class="num">{{ item.num }}</span>
        </div>
        <div class="block-right">
          <div class="icon-swap">
            <div
              v-if="item.icon"
              class="icon"
              :style="{
                background: `url(${item.icon}) no-repeat`,
                'background-size': 'contain'
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import dianjin from './images/dianjin.png'
// import jinnang from './images/jinnang.png'
// import course from './images/course.png'
import fans from './images/fans.png'
import htest from './images/h-test.png'

export default {
  name: 'AuthorInfoHeader',
  data() {
    return {}
  },
  computed: {
    blockData() {
      var data = [
        // {
        //   name: '点金',
        //   num: 120,
        //   icon: dianjin
        // },
        // {
        //   name: '锦囊',
        //   num: 4,
        //   icon: jinnang
        // },
        // {
        //   name: '课程',
        //   num: 56,
        //   icon: course
        // },
        {
          name: '粉丝数',
          num: this.authorInfo.fanscount,
          icon: fans
        }
      ]
      return data
    },

    headIcon() {
      return htest
    },

    isSurePassWord() {
      return false
    },
    isResetSucess() {
      return false
    },
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    authorInfo() {
      return this.$store.state.user.authorInfo
    },
    userInfo() {
      return this.$store.state.user.userInfo
    },
    authorType() {
      switch (this.authorInfo.atype) {
        case 0:
          return '投资顾问'
        case 1:
          return '分析师'
        case 2:
          return '特约嘉宾'
        case 3:
          return '理财师'
        default:
          return '投资顾问'
      }
    },
    avatar() {
      var res = !this.authorInfo ? '' : this.authorInfo.headpic1
      if (!res) {
        res = !this.userInfo ? '' : this.userInfo.avatar
      }
      return res
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.author-info-header {
  display: flex;
  height: 120px;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 5px;
  .author-info-left {
    display: flex;
    margin-left: 50px;
    align-items: center;
    .head-img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .head-text {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      .name {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #262626;
      }
      .title {
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #858585;
        // width: 150px;
        span {
          color: #858585;
        }
        .line {
          width: 1px;
          margin: 0 10px;
          height: 14px;
          background-color: #858585;
        }
      }
    }
  }
  .author-info-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .block {
      display: flex;
      width: 140px;
      height: 80px;
      background-color: #fafafa;
      border-radius: 5px;
      justify-content: space-between;
      margin-right: 20px;
      .block-left {
        display: flex;
        width: 90px;
        flex-direction: column;
        justify-content: center;

        margin: 0;
        .name {
          padding-left: 20px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 28px;
          letter-spacing: 0px;
          color: #858585;
        }
        .num {
          padding-left: 20px;
          font-family: MicrosoftYaHei;
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 35px;
          letter-spacing: 0px;
          color: #262626;
        }
      }
      .block-right {
        display: flex;
        width: 50px;
        .icon-swap {
          width: 46px;
          height: 46px;
          display: flex;
          justify-content: center;
          align-items: center;
          .icon {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>
